<template>
    <div class="modal-backdrop" @click.self="$emit('close')">
      <div class="modal-custom">
        <div class="modal-header">
          <h5>Group Info</h5>
          <button @click="$emit('close')" class="btn btn-sm btn-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="group-details">
            <h6>{{ group.name }}</h6>
            <p>{{ group.description || 'No description' }}</p>
            <p>Created by: {{ group.creator?.name }}</p>
            <p>Created at: {{ formatDate(group.created_at) }}</p>
            <p>Type: {{ group.is_public ? 'Public' : 'Private' }}</p>
            <p v-if="group.class">Class: {{ group.class.name }}</p>
            <p v-if="group.section">Section: {{ group.section.name }}</p>
          </div>
          
          <div class="members-list">
            <h6>Members ({{ group.members?.length || 0 }})</h6>
            <div v-for="member in group.members" :key="member.id" class="member-item">
              <div class="member-avatar">
                <i class="fas fa-user"></i>
              </div>
              <div class="member-info">
                <strong>{{ member.name }}</strong>
                <small>{{ member.user_type }}</small>
              </div>
              <div class="member-status">
                <span v-if="member.pivot?.is_admin" class="badge admin">Admin</span>
                <span v-if="member.pivot?.is_blocked" class="badge blocked">Blocked</span>
                <span v-if="member.is_online" class="badge online">Online</span>
                <span v-else class="badge offline">Offline</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      group: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatDate(dateString) {
        return new Date(dateString).toLocaleDateString();
      },
    //   isUserOnline(member) {
    //     if (!member.last_activity) return false;
    //     const lastActivity = new Date(member.last_activity);
    //     const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000);
    //     return lastActivity > fiveMinutesAgo;
    //   }
    }
  };
  </script>
  
  <style scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-custom {
  background: white;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease-out;
}
  
  .modal-header {
    padding: 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-body {
    padding: 15px;
  }
  
  .member-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f5f5f5;
  }
  
  .member-avatar {
    margin-right: 10px;
  }
  
  .member-info {
    flex: 1;
  }
  
  .badge {
    padding: 3px 6px;
    border-radius: 4px;
    font-size: 12px;
    margin-left: 5px;
  }
  
  .badge.admin {
    background-color: #4CAF50;
    color: white;
  }
  
  .badge.blocked {
    background-color: #F44336;
    color: white;
  }
  
  .badge.online {
    background-color: #8BC34A;
    color: white;
  }
  
  .badge.offline {
    background-color: #9E9E9E;
    color: white;
  }
  </style>